import React, { Component } from 'react';
import {UISref} from 'ui-router-react'; 

class NotfoundContainer extends Component {
	render() {	
			const { label_not_found,label_not_fond_text,label_back_home } = this.props.resolves.staticData;
		   return (
				<div className="not_found_container">
					<div className="not_found">
						<h1>{label_not_found}</h1>
						<div className="subheading">{label_not_fond_text}</div>
						<UISref to="root.home">
							<button className="btn dark-btn">{label_back_home}</button>
						</UISref>
					</div>
				</div>
			)
	   
	}
}
export default NotfoundContainer;


// WEBPACK FOOTER //
// ./src/containers/NotfoundContainer.js